import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

export default function Footer() {
  const shopCategories = categories.slice(0, 6);
  const guideLinks = [
    { name: "What is OOPBuy", path: "/what-is-oopbuy-spreadsheet" },
    { name: "Beginner Guide", path: "/oopbuy-spreadsheet-beginner-guide" },
    { name: "Setup Tutorial", path: "/how-to-use-oopbuy-spreadsheet" },
    { name: "Best Template", path: "/best-oopbuy-spreadsheet-template" },
    { name: "Advanced System", path: "/advanced-oopbuy-tracking-system" },
    { name: "FAQ", path: "/what-is-oopbuy-spreadsheet" },
  ];
  const legalLinks = [
    { name: "Privacy Policy", path: "#privacy" },
    { name: "Terms of Service", path: "#terms" },
    { name: "Contact", path: "#contact" },
  ];

  return (
    <footer className="w-full bg-secondary-200 pt-12 md:pt-16 pb-6">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-4 right-8 w-16 h-24 bg-accent-200 rounded-lg -rotate-12 opacity-60"></div>
          <div className="absolute bottom-4 left-8 w-20 h-16 bg-primary-200 rounded-lg rotate-6 opacity-50"></div>

          <div className="relative z-10 flex flex-col lg:flex-row gap-10 lg:gap-20">
            <div className="lg:w-1/3">
              <Link to="/" className="font-heading font-bold text-xl text-foreground-950 whitespace-nowrap">
                oopbuyspreadsheets.pics
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
                Your gateway to the ultimate product tracking spreadsheet system. Discover tools, guides, and resources to streamline your e-commerce sourcing workflow.
              </p>
            </div>

            <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
              <div className="flex flex-col gap-3">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-1">
                  Shop
                </h4>
                {shopCategories.map((cat, idx) => (
                  <a
                    key={idx}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-700 hover:text-accent-700 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>

              <div className="flex flex-col gap-3">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-1">
                  Guides
                </h4>
                {guideLinks.map((link, idx) => (
                  <Link
                    key={idx}
                    to={link.path}
                    className="text-sm text-foreground-700 hover:text-accent-700 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>

              <div className="flex flex-col gap-3">
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-1">
                  Legal
                </h4>
                {legalLinks.map((link, idx) => (
                  <a
                    key={idx}
                    href={link.path}
                    className="text-sm text-foreground-700 hover:text-accent-700 transition-colors duration-150 cursor-pointer whitespace-nowrap"
                  >
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="relative z-10 mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>&copy; 2026 oopbuyspreadsheets.pics</span>
              <span className="hidden sm:inline text-background-300">|</span>
              <a href="#privacy" className="hover:text-accent-700 transition-colors duration-150 cursor-pointer">Privacy</a>
              <span className="text-background-300">|</span>
              <a href="#terms" className="hover:text-accent-700 transition-colors duration-150 cursor-pointer">Terms</a>
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-950 text-white flex items-center justify-center cursor-pointer hover:bg-accent-700 transition-colors duration-150">
                <i className="ri-twitter-x-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-950 text-white flex items-center justify-center cursor-pointer hover:bg-accent-700 transition-colors duration-150">
                <i className="ri-linkedin-fill text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}